enum AttributeType {
    STRING = 'STRING',
    HTML = 'HTML',
    BOOLEAN = 'BOOLEAN',
    QUANTITY = 'QUANTITY',
    NUMERIC = 'NUMERIC',
    DURATION = 'DURATION',
}

enum ProductType {
    EXPERIENCE = 'EXPERIENCE',
    BOX = 'BOX',
    VALUE_VOUCHER = 'VALUE_VOUCHER',
}

enum ShippingMethodType {
    online = 'online',
    express = 'express',
    standard = 'standard',
    box_express = 'box_express',
    box_standard = 'box_standard',
}

enum XmasNoticeType {
    ShippingNoticeStandardOn = 'SHIPPING_NOTICE_STANDARD_ON',
    XmasNoticeDeOn = 'XMAS_DE_ON',
    ShippingNoticeDEOn = 'SHIPPING_NOTICE_DE_ON',
    ExpressShippingHintDeOn = 'EXPRESS_SHIPPING_HINT_DE_ON',
}

enum ProductPromotionType {
    None = 'None',
    Friends = 'Friends',
    CustomerClub = 'CustomerClub',
}

const ProductPromotionTypeTrackingLabel = {
    [ProductPromotionType.None]: 'None',
    [ProductPromotionType.Friends]: 'Friends Deal',
    [ProductPromotionType.CustomerClub]: 'Member Club',
};

export {
    AttributeType,
    ProductPromotionType,
    ProductPromotionTypeTrackingLabel,
    ProductType,
    ShippingMethodType,
    XmasNoticeType,
};
